
import { mapActions, mapState, mapGetters } from "vuex";
export default {
  props: {
    brand: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      isActive: false,
      loading: false
    };
  },
  mounted() {
    this.initStatus();
  },
  computed: {
    ...mapGetters("restaurant", ["isBrandOnline"]),
    ...mapState("restaurant", ["locationDetails"])
  },
  watch: {
    locationDetails() {
      this.initStatus();
    }
  },
  methods: {
    ...mapActions("reciever", ["patchRestaurantState"]),
    initStatus() {
      this.isActive = this.isBrandOnline(this.brand.id);
    },
    handleSwitchToggle(val) {
      this.loading = true;
      this.patchRestaurantState({
        id: this.brand.id,
        payload: { new_state: val ? "online" : "offline" }
      })
        .then((response) => {
          this.$nuxt.$emit("show-toast", {
            text: response?.data?.message,
            color: "success darken-2",
            icon: "done",
            flat: true
          });
        })
        .catch((errr) => {
          this.isActive = !val;
          this.$nuxt.$emit("show-error-toast", errr);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
